import { render } from "./CaptionEditor.vue?vue&type=template&id=490d4568&scoped=true"
import script from "./CaptionEditor.vue?vue&type=script&lang=js"
export * from "./CaptionEditor.vue?vue&type=script&lang=js"

import "./CaptionEditor.vue?vue&type=style&index=0&id=490d4568&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-490d4568"

export default script